export default __webpack_public_path__ + "static/media/smallLogo.8cfec47d.svg";